import { useI18n } from 'i18n/useI18n';
import { NullImg } from 'pages/webapp/page_one/mine/nullImg';
import RoundImg from '../img/round-img';

export default function NoDataTip() {
  const { t } = useI18n();
  return (
    <center className=" m-16">
      <RoundImg
        src={NullImg}
        style={{ width: 200 }}
      />
      <p style={{ margin: '10px' }}>{t('no-data-tip.index.180776-0')}</p>
    </center>
  );
}
